import React, { useState } from "react";

import { RequiredMark, ErrorMessage } from "@components/inputs/shared";
import {
	SowCustomCheckboxField,
	SowCustomInputField,
} from "@features/player-sow/shared/inputs";
import { MappedQuestionType } from "@data-types/sow/PlayerSowTypes";

import { MultiSelectOptionType } from "@data-types/sow/PlayerSowEnums";

import { useFormContext } from "react-hook-form";
export const SowMultiSelect = (props: { question: MappedQuestionType }) => {
	const { question } = props;

	const [isOtherChecked, setIsOtherChecked] = useState(false);

	const { resetField } = useFormContext();

	const handleOtherCheck = (checked: boolean) => {
		if (checked == false) {
			resetField(`${question.abrv}-custom`);
		}
		setIsOtherChecked(checked);
	};

	return (
		<div className="form__field">
			<label className="label u-mar--bottom--tny u-type--wgt--medium">
				{question.name}
				<RequiredMark required />
			</label>
			<ErrorMessage name={question.abrv} />
			{question.mappedOptions &&
				question.mappedOptions.map((option) => {
					if (option.type == MultiSelectOptionType.Text) {
						return (
							<>
								<SowCustomCheckboxField
									name={question.abrv}
									id={option.id}
									label={option.name}
									value={option.id}
									key={option.id}
									setOther={handleOtherCheck}
									required
								/>

								<SowCustomInputField
									name={`${question.abrv}-custom`}
									label={option.name}
									labelClassName="u-type--wgt--medium"
									required={isOtherChecked}
									disabled={!isOtherChecked}
								/>
							</>
						);
					}
					return (
						<SowCustomCheckboxField
							name={question.abrv}
							id={option.id}
							label={option.name}
							value={option.id}
							key={option.id}
							required
						/>
					);
				})}
		</div>
	);
};
